import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';

interface TablePageHeaderProps {
  name: string;
}

const TablePageHeader = ({ name }: TablePageHeaderProps) => {
  return (
    <View style={styles.container}>
      <Image style={styles.logo} src="../../../../../../public/assets/images/Skyhop_global_logo.png" />
      <Text style={styles.title}>{name}</Text>
      <Text style={styles.pageHeaderLeft} />
      <Text style={styles.pageHeaderRight} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    maxHeight: '300px',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingRight: 14,
    paddingLeft: 14,
    borderBottom: '1px solid #D9D9D9',
    position: 'relative',
    top: 0,
    marginBottom: 19,
  },
  pageHeaderLeft: {
    position: 'absolute',
    bottom: -5,
    left: 0,
    width: 77,
    height: 5,
    backgroundColor: '#FF9E16',
  },
  pageHeaderRight: {
    position: 'absolute',
    bottom: -5,
    right: 0,
    width: 77,
    height: 5,
    backgroundColor: '#40ADE2',
  },
  logo: {
    width: '150px',
    height: '56px',
  },
  title: {
    color: '#40ADE2',
    fontSize: 20,
    fontWeight: 350,
    textTransform: 'uppercase',
  },
});

export default TablePageHeader;
